import type { ExploreContentItemContentOneOfFivezeroMediaLinksItemProjectInfoEngagementAllOf } from './exploreContentItemContentOneOfFivezeroMediaLinksItemProjectInfoEngagementAllOf';
import type { ExploreContentItemContentOneOfFivezeroMediaLinksItemProjectInfoEngagementAllOfTwo } from './exploreContentItemContentOneOfFivezeroMediaLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type ExploreContentItemContentOneOfFivezeroMediaLinksItemProjectInfoEngagement = ExploreContentItemContentOneOfFivezeroMediaLinksItemProjectInfoEngagementAllOf & ExploreContentItemContentOneOfFivezeroMediaLinksItemProjectInfoEngagementAllOfTwo;
